<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="page-header">
            <span>{{PageHeading}}</span>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
            <div class="card-block">
                <p-accordion [multiple]="false" (onOpen)="OnOpenCloseAccordingControl(true)" (onClose)="OnOpenCloseAccordingControl(false)">
                    <p-accordionTab header="Filter Result" [selected]="IsFilterTabSelected">
                        <div class="ui-grid ui-grid-responsive ui-grid-pad ui-fluid" style="margin: 10px 0px">
                            <div class="ui-grid-row">
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Search By Name</span>
                                        <input type="text" placeholder="Employee name" pInputText
                                               [(ngModel)]="SearchText" style="width:50%;">
                                    </div>
                                </div>
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Total Years of Experience</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="YearOfExperience"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedYearOfExperience"
                                                       (onPanelHide)="OnFilterSelection(8)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="ui-grid-row">
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Competency</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="SMUList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedSMUList"
                                                       (onPanelHide)="OnFilterSelection(0)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="ui-grid-row">
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Engagement Type</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="EngTypeList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedEngTypeList"
                                                       (onPanelHide)="OnFilterSelection(1)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Engagement Sub Type</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="EngSubTypeList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedEngSubTypeList"
                                                       (onPanelHide)="OnFilterSelection(2)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="ui-grid-row">
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Market Segment</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="MarketSegmentList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedMarketSegmentList"
                                                       (onPanelHide)="OnFilterSelection(3)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="ui-grid-row">
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Engagement Sector</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="EngSectorList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedEngSectorList"
                                                       (onPanelHide)="OnFilterSelection(4)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Engagement Sub Sector</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="EngSubSectorList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedEngSubSectorList"
                                                       (onPanelHide)="OnFilterSelection(5)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                            </div>
                            <div class="ui-grid-row">
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Geographic Type</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="GeographicTypeList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedGeographicTypeList"
                                                       (onPanelHide)="OnFilterSelection(6)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                                <div class="ui-grid-col-6">
                                    <div class="ui-inputgroup">
                                        <span class="ui-inputgroup-addon">Designations</span>
                                        <p-multiSelect [filter]="true"
                                                       [options]="DesignationsList"
                                                       optionLabel="Text"
                                                       [(ngModel)]="SelectedDesignationsList"
                                                       (onPanelHide)="OnFilterSelection(7)"
                                                       [style]="{'width':'365.750px'}">
                                        </p-multiSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <p-table #dt [columns]="cols"
                 [value]="RequestDetailsList"
                 [(selection)]="SelectedRequestDetailsList"
                 [loading]="loading"
                 [paginator]="true"
                 [rows]="10"
                 autoLayout="true"
                 responsive="true"
                 [first]="first"
                 (onPage)="paginate($event)">
            <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                    <button pButton
                            icon="fa fa-search"
                            iconPos="left"
                            type="button"
                            label="Search Personnel"
                            (click)="GetResult()"
                            style="float:left"></button>
                    <button pButton
                            icon="fa fa-refresh"
                            iconPos="left"
                            type="button"
                            label="Reset"
                            (click)="RefreshSearchResult()"
                            style="float:left"></button>
                    <button type="button"
                            pButton icon="fa fa-window-close-o"
                            iconPos="left"
                            label="Exit"
                            style="float:left" [routerLink]="['/home/dashboard']"></button>
                    <button type="button"
                            pButton icon="fa fa-cart-plus"
                            iconPos="left"
                            label="Add To Cart"
                            style="float:left"
                            (click)="AddToCart()"
                            [disabled]="SelectedRequestDetailsList.length<=0"></button>
                </div>
                <div class="ui-helper-clearfix" *ngIf="RequestDetailsList.length > 0">
                    <br />
                    <div style="float:left">
                        {{RequestDetailsList.length}} relevant records found
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <ng-container *ngFor="let col of columns">
                        <th [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                    </ng-container>
                </tr>
                <tr *ngIf="RequestDetailsList.length <= 0">
                    <th colspan="11">
                        <div style="color:red !important">Records not found!</div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                    <td style="vertical-align:top;">
                        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <ng-container *ngFor="let col of columns">
                        <td style="vertical-align:top;">
                            <ng-container *ngIf="col.field==='ResumeId';else second">
                                <a style="color:blue;cursor: pointer;"
                                   (click)="onCickRequestNumber(rowData.ResumeId)">{{rowData[col.field]}}</a>
                            </ng-container>
                            <ng-template #second>
                                <div>{{rowData[col.field]}}</div>
                            </ng-template>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>